<template>
  <div>
    <b-row class="mt-3"><b-col><b><BaseELabel class="mb-2" label="Details" new-style /></b></b-col></b-row>
    <div class="border" :class="$style.arsContainer">
    <b-row>
      <b-col class="border mx-2 mr-4 py-2 text-white text-center" :class="$style.sContainer"><b>S</b></b-col>
      <b-col md="2" class="mt-1"><b>Distance: </b>{{ formatDisplay(arsData.distance) }}</b-col>
      <b-col md="4" class="mt-1"><b>Address: </b>{{ formatDisplay(arsData.address) }}</b-col>
      <b-col md="3" class="mt-1"><b>Sale Price: </b>{{ formatDisplay(arsData.salePrice) }}</b-col>
      <b-col md="2" class="mt-1"><b>REO: </b>{{ formatDisplay(arsData.reo) }}</b-col>
    </b-row>
    <b-row class="mx-1">
      <b-col><b>Owner: </b>{{ formatDisplay(arsData.owner) }}</b-col>
      <b-col><b>Property Type: </b>{{ formatDisplay(arsData.propertyType) }}</b-col>
      <b-col><b>No. of Stories: </b>{{ formatDisplay(arsData.noOfStories) }}</b-col>
    </b-row>
    <b-row class="mx-1">
      <b-col><b>Beds/Baths: </b><span v-if="arsData.beds || arsData.bath">{{ formatDisplay(arsData.beds) + ' / ' + formatDisplay(arsData.bath) }}</span></b-col>
      <b-col><b>Design Style: </b>{{ formatDisplay(arsData.designStyle) }}</b-col>
      <b-col><b>Assessed Value: </b>{{ formatDisplay(arsData.assessedValue) }}</b-col>
    </b-row>
    <b-row class="mx-1">
      <b-col><b>Total Rooms: </b>{{ formatDisplay(arsData.totalRooms) }}</b-col>
      <b-col><b>Garages: </b>{{ formatDisplay(arsData.garages) }}</b-col>
      <b-col><b>% Improvements: </b>{{ formatDisplay(arsData.percentageImprovements) }}</b-col>
    </b-row>
    <b-row class="mx-1">
      <b-col><b>Living Area: </b>{{ formatDisplay(arsData.livingArea) }}</b-col>
      <b-col><b>Garage Area: </b>{{ formatDisplay(arsData.garageArea) }}</b-col>
      <b-col><b>APN: </b>{{ formatDisplay(arsData.apn) }}</b-col>
    </b-row>
    <b-row class="mx-1">
      <b-col md="4"><b>Basement Fin. Area: </b>{{ formatDisplay(arsData.basementFinArea) }}</b-col>
      <b-col md="4"><b>Subdivision: </b>{{ formatDisplay(arsData.subDivision) }}</b-col>
    </b-row>
    <b-row class="mx-1">
      <b-col md="4"><b>Lot Size (acres): </b>{{ formatDisplay(arsData.lotSize) }}</b-col>
      <b-col md="4"><b>Heat/AC: </b><span v-if="arsData.heat || arsData.ac">{{ formatDisplay(arsData.heat) + ' / ' + formatDisplay(arsData.ac) }}</span></b-col>
    </b-row>
    <b-row class="mx-1">
      <b-col md="4"><b>Year Built: </b>{{ formatDisplay(arsData.yearBuilt) }}</b-col>
    </b-row>
    <b-row class="ml-1 mt-3"><b-col><BaseELabel label="Sale Transfers" new-style /></b-col></b-row>
    <b-row class="mx-1 my-1">
      <b-col>
        <b-table
          responsive
          striped
          bordered
          :fields="areaFields"
          :items="arsSaleTransfersData"
          class="mb-0 fraudReportHeaderTable"
        ></b-table>
        <NoRecordFound
          v-if="!arsSaleTransfersData.length"
        ></NoRecordFound>
      </b-col>
    </b-row>
  </div>
  </div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
export default {
  components: { NoRecordFound },
  props: {
    arsDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      areaFields: [
        { key: 'saleDate', label: 'Sale Date', class: 'text-right', },
        { key: 'salePrice', label: 'Sale Price'},
        { key: 'transferType', label: 'Transfer Type'},
        { key: 'perChangePrice', label: '% Price Change From Prior Sale (nominal/annualized)', tdClass: 'textTruncatee',thStyle: { width: '280px' }},
        { key: 'perChangeHpi', label: '% HPI Change From Prior Sale (segment)', tdClass: 'textTruncatee',thStyle: { width: '200px' }},
        { key: 'sqftAmount', label: '$/sq ft'},
        { key: 'buyerSeller', label: 'Buyer/Seller', tdClass: 'textTruncatee',thStyle: { width: '300px' }},
      ],
    }
  },
  computed: {
    arsData(){
      return this.arsDetails.arsData || {}
    },
    arsSaleTransfersData(){
      return this.arsDetails.arsSaleTransfersData
    },
  },
  methods: {
    formatDisplay(value) {
      return value || ''
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.arsContainer {
  padding: 0 5px 5px 5px;
  font-size: 13px;
  background: $color-text-white;
}
.sContainer {
  background: $color-dark-purple;
}

</style>
